import styled from "styled-components";

export const StyledProjectSection = styled.div`
  height: calc(100vh - 64px);
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  width: 98%;
`;
